export const rsvpEmailTemplate = {
  subject: "RSVP - Cat & Rich's Wedding",
  body: `Dear Cat and Rich,

I am writing to RSVP for your wedding.

Name(s):
Number of guests:

☐ I will be attending
☐ I will not be able to attend

Dietary requirements or allergies:

Additional notes:

Looking forward to celebrating with you!

Best regards,`
};

export const createMailtoLink = (email: string, subject: string, body: string): string => {
  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);
  return `mailto:${email}?subject=${encodedSubject}&body=${encodedBody}`;
};